module.exports = __webpack_public_path__ + "media/images/icons/iphone-aa0e5cc38559db4448be1148895b41b1.png";